"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeysListPropsSchema = exports.PatchFeatureExpKeyFlagshipAPIPayloadSchema = exports.PostFeatureExpKeyFlagshipAPIPayloadSchema = exports.DeleteFeatureExpKeyFlagshipAPIPayloadSchema = exports.FeatureExpKeyWithPaginationSchema = exports.FeatureExpKeySchema = exports.FeatureExpKeySortablePropSchema = exports.AllowedKeyTypesSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../schemas");
exports.AllowedKeyTypesSchema = zod_1.z.enum(['string', 'number', 'boolean']);
exports.FeatureExpKeySortablePropSchema = zod_1.z.enum(['name', 'createdAt']);
exports.FeatureExpKeySchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    type: exports.AllowedKeyTypesSchema,
    description: zod_1.z.string(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
    is_used: zod_1.z.boolean(),
});
exports.FeatureExpKeyWithPaginationSchema = schemas_1.FeatureExpPaginationSchema.extend({
    items: zod_1.z.array(exports.FeatureExpKeySchema),
});
exports.DeleteFeatureExpKeyFlagshipAPIPayloadSchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    keyId: zod_1.z.string(),
});
exports.PostFeatureExpKeyFlagshipAPIPayloadSchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    type: zod_1.z.string(),
});
exports.PatchFeatureExpKeyFlagshipAPIPayloadSchema = zod_1.z.object({
    accountId: zod_1.z.string(),
    keyId: zod_1.z.string(),
    name: zod_1.z.string().optional(),
    description: zod_1.z.string().optional(),
    type: zod_1.z.string().optional(),
});
exports.KeysListPropsSchema = schemas_1.FeatureExpPaginationQueryParamSchema.and(zod_1.z.object({
    accountId: zod_1.z.string(),
    search: zod_1.z
        .object({
        name: zod_1.z.string().optional(),
        type: zod_1.z.string().optional(),
    })
        .optional(),
    _order: zod_1.z
        .object({
        name: schemas_1.OrderBySchema.optional(),
        created_at: schemas_1.OrderBySchema.optional(),
    })
        .optional(),
}));
//# sourceMappingURL=schemas.js.map